export default __webpack_public_path__ + "static/media/headphone-left-wire.f560c51d.svg";